var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart_wrap"},[(_vm.title !== '')?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('canvas',{staticClass:"myChart",attrs:{"id":_vm.id,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }